import { render, staticRenderFns } from "./update.vue?vue&type=template&id=0d71f1f9&scoped=true&"
import script from "./update.vue?vue&type=script&lang=js&"
export * from "./update.vue?vue&type=script&lang=js&"
import style0 from "./update.vue?vue&type=style&index=0&id=0d71f1f9&prod&scoped=true&lang=css&"
import style1 from "./update.vue?vue&type=style&index=1&id=0d71f1f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71f1f9",
  null
  
)

export default component.exports